
<template>
    <component :is="'div'">

        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="blogData === undefined"
        >
            <h4 class="alert-heading">Error al obtener los datos del blog</h4>
            <div class="alert-body">
                No se encontró ningún blog con este id. Verificar en la
                <b-link
                    class="alert-link"
                    :to="{ name: 'blogs'}"
                >
                    Lista de blogs
                </b-link>
                para buscar otro blog
            </div>
        </b-alert>

        <blog-edit-tab-information
            v-if="blogData"
            :blog-data="blogData"
        />
    </component>
</template>

<script>

    import BlogEditTabInformation from './BlogEditTabInformation.vue';
    import { onUnmounted, ref } from '@vue/composition-api';
    import blogStoreModule from '../blogStoreModule';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            BlogEditTabInformation
        },
        setup() {
            const blogData = ref(null);

            const BLOG_APP_STORE_MODULE_NAME = 'app-blog';

            // Register module
            if (!store.hasModule(BLOG_APP_STORE_MODULE_NAME)) store.registerModule(BLOG_APP_STORE_MODULE_NAME, blogStoreModule);

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(BLOG_APP_STORE_MODULE_NAME)) store.unregisterModule(BLOG_APP_STORE_MODULE_NAME)
            });

            store.dispatch('app-blog/fetchBlog', { id: router.currentRoute.params.id })
                .then(response => {
                    if (response.data === 'error') {
                        blogData.value = undefined
                    } else {
                        blogData.value = response.data;
                    }
                })
                .catch(error => {
                    if (error.response.status === 404) {
                        blogData.value = undefined
                    }
                });

            return {
                blogData
            }
        }
    }

</script>
